// HelpBanner.js
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import sparklesIcon from "assets/sparkles.svg";
import { isHaddockHostname } from "utils/haddockDomain";

const HelpBanner = ({ title, text, linkText, linkHref, delayTime = 1500 }) => {
	const [isVisible, setIsVisible] = useState(false);

	// Check if we're on a Haddock domain
	const domain = window.location.hostname;
	const isHaddockDomain = isHaddockHostname(domain);

	// Don't render the banner at all for Haddock domains
	if (isHaddockDomain) {
		return null;
	}

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsVisible(true);
		}, delayTime);

		return () => clearTimeout(timer);
	}, [delayTime]);

	return (
		<div className={`help-banner ${isVisible ? "visible" : ""}`}>
			<img src={sparklesIcon} alt="Sparkles" />
			<span className="help-banner-title tablet-hidden">{title}</span>
			<span className="help-banner-text tablet-hidden">{text}</span>
			{linkText && linkHref && (
				<a
					href={linkHref}
					className="help-banner-link"
					target="_blank"
					rel="noopener noreferrer"
				>
					<span className="tablet-hidden">{linkText}</span>
					<span className="mobile-only">{title}</span>
				</a>
			)}
		</div>
	);
};

HelpBanner.propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    linkText: PropTypes.string,
    linkHref: PropTypes.string,
    delayTime: PropTypes.number,
};

export default HelpBanner;
